import { VideoPlayer } from "../../../../modules/content/components/VideoPlayer/VideoPlayer";
import { VelvetCommonContent } from "../../../../modules/content/components/VelvetCommonContent/VelvetCommonContent";
import { VelvetSection } from "../../../../modules/content/components/VelvetSection/VelvetSection";
import type { IVideoBlockProps } from "./VideoBlock.props";

export const VideoBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
  videoBanner,
  videoSource,
  vimeoVideo,
  youtubeVideo,
}: IVideoBlockProps) => {
  const selectedVideo = videoSource === "youtube" ? youtubeVideo : vimeoVideo;
  if (!selectedVideo) return null;
  return (
    <VelvetSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="grid gap-16 lg:grid-cols-12 lg:gap-y-24">
        <VelvetCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          className="lg:col-span-8"
        />
        <div className="velvet-unveil border-y border-parchment/20 py-4 lg:col-span-10 lg:col-start-3">
          <VideoPlayer
            banner={videoBanner}
            source={videoSource}
            vimeoVideo={vimeoVideo}
            youtubeVideo={youtubeVideo}
          />
        </div>
      </div>
    </VelvetSection>
  );
};

VideoBlock.displayName = "Block::VideoBlock";
